// The box a cloud is drawn in. Its width is the one the mounting view fixes, else the one the block
// measures for itself; its height follows from that width, by the orientation the config asks for.
//
// The ratios are the cloud's own proportions, stated against the report width they were drawn at.

const HORIZONTAL_RATIO = 426 / 662
const VERTICAL_RATIO = 855 / 662

// what a cloud is drawn at when there is no report column to measure -- the width the ratios above
// are stated against, so the proportions hold whichever way the width was arrived at
export const DEFAULT_WIDTH = 662

export const calcCloudBox = ({ width, height, measuredWidth, orientation } = {}) => {
  const boxWidth = width || measuredWidth || DEFAULT_WIDTH

  return {
    width: boxWidth,
    height: height || ('h' === orientation ? HORIZONTAL_RATIO : VERTICAL_RATIO) * boxWidth
  }
}
